<template>
    <div class="footer">
        <div class="row">
            <div class="col-6 mr-0 pr-0 col-sm-6 col-md-5 col-lg-6 p-md-4 ml-0 footer-text text-left">
                Creado y diseñado por:
                <img class="footer-logo" :src="logo_movigoo_src">
            </div>
            <div class="col-6 mr-0 p-0 col-sm-6 pr-sm-1 col-md-7 p-md-4 col-lg-6 col-xl-6 mr-0 footer-text text-right">
                ¿Algo no funciona? Comunicate con Soporte: <u>soporte@movigoo.com</u>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                logo_src: 'img/logo.png',
                logo_movigoo_src: 'img/logo_movigoo.png',
            }
        }
    }
</script>
<style>
    .footer-logo {
        width: 60px;
        height: 16px;
    }

    .footer-text {
        width: 389px;
        height: 13px;
        font-family: ProximaNova;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: normal;
        color: #777777;
    }

    .footer {
        position: absolute;
        bottom: 0;
        margin-left: 15px;
        margin-right: 15px;
        width: 98%;
        height: 60px;
        /* Set the fixed height of the footer here */
        line-height: 60px;
        /* Vertically center the text there */
        /* background-color: #f5f5f5; */
    }
</style>